import type { Author } from '../../types/article'

export const authors: Author[] = [
  {
    id: 'claudine',
    name: 'Claudine Mukamana',
    role: 'Business writer, Kayko',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/e542df9e-0dc4-40f6-89bc-8c8f364a8b5c.jpg',
    bio: 'Claudine writes practical guides for shop owners and small businesses across Rwanda. Before Kayko, she ran her family’s grocery in Huye for six years.',
  },
  {
    id: 'eric',
    name: 'Eric Nkurunziza',
    role: 'Small business adviser, Kayko',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/931ce188-3f96-4383-a463-1f2d80cd7bda.jpg',
    bio: 'Eric helps Kayko customers set up their stock, pricing, and reports. He has advised more than 400 small businesses in Kigali on bookkeeping and cash flow.',
  },
]

export function getAuthor(id: string): Author {
  return authors.find((a) => a.id === id) ?? authors[0]
}
